import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-cream px-4 py-16 sm:py-24" aria-labelledby="testimonials-title" data-id="element-315" data-mp="3fxun461bgqtd">
      <div className="mx-auto max-w-5xl" data-id="element-316" data-mp="3b01fd8kd7oqz">
        <div id="testimonials-title" data-id="element-317" data-mp="36ypokzpr8xh7">
          <SectionHeading eyebrow="What dental professionals are saying" title={<>A Better Way to Organize <span className="italic text-gold" data-id="element-319" data-mp="31yl4z0tjvmmr">Complex Rehabilitation Cases</span></>} data-id="element-318" data-mp="36zr0f6elhnzz" />
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-320" data-mp="2x2w48u5snzov">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-sm ring-1 ring-navy/10" data-id="element-321" data-mp="2s3t9c2jj39um">
              <div className="flex items-center gap-4" data-id="element-322" data-mp="v72hdl3aj2kr">
                <img src={t.image} alt={`Portrait of ${t.name}`} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-gold" loading="lazy" data-id="element-323" data-mp="qbn7f48elqtm" />
                <div className="min-w-0" data-id="element-324" data-mp="m2op534f6apk">
                  <p className="font-serif text-lg font-bold text-navy" data-id="element-325" data-mp="78tvh4cu4ryy">{t.name}</p>
                  <p className="text-sm text-ink-muted" data-id="element-326" data-mp="c6bua1x51qt8">{t.role}</p>
                  <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-327" data-mp="c8oj8z1bd1fs">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} aria-hidden="true" className="h-4 w-4 fill-gold text-gold" data-id="element-328" data-mp="14uhfsqw0nju4" data-mpi={i} />)}
                  </div>
                </div>
              </div>
              <blockquote className="relative mt-5 flex-1 text-[16px] leading-relaxed text-navy" data-id="element-329" data-mp="v4xu7dgx5bvk">
                <QuoteIcon aria-hidden="true" className="mb-2 h-6 w-6 text-gold/50" data-id="element-330" data-mp="1iv1xfjq739m1" />
                {t.quote}
              </blockquote>
              <p className="mt-5 rounded-lg bg-gold-pale px-3 py-2 text-xs font-semibold text-navy" data-id="element-331" data-mp="1nnbk8qw0jtk3">{t.tool}</p>
            </li>)}
        </ul>

        <div className="mt-12" data-id="element-332" data-mp="1siedlassaxul">
          <CtaButton label="I Want to Organize My Cases With Greater Clarity" data-id="element-333" data-mp="1sjfn3au5jca7" />
        </div>
      </div>
    </section>;
}